'use client'

import React from 'react'

import { BaseForm, BaseFormProps } from './styles'

export interface FormProps extends BaseFormProps {
  /**
   * Children
   */
  children?: React.ReactNode
}

/**
 * Form component
 */
export const Form = ({ children, ...rest }: FormProps) => {
  return <BaseForm {...rest}>{children}</BaseForm>
}
